/* Wholesale notes store - wholesale pages only.
   Notes live in the Google Sheet through window.WSApi, keyed to the current client, so they are
   cross-device. add() is OPTIMISTIC: the toast and header count update the moment the button is
   tapped, the sheet write happens in the background, and on failure the count rolls back and an
   error toast shows. The server-known count and the in-flight count are tracked separately so a
   background context refresh can never undo an optimistic bump. remove() deletes the row. There
   is NO local cart mirror: the notes page reads the sheet directly, so nothing here reloads the
   page. Loaded from wholesale-header.liquid after wholesale-api.js. */
(function () {
  var W = (window.WSNotes = window.WSNotes || {});
  var api = window.WSApi;
  var byVariant = {};
  var noteCount = 0;   // count the sheet knows about
  var pending = 0;     // optimistic adds still in flight
  var clientId = null;
  var readyP = null;

  function render() {
    var n = noteCount + pending;
    document.querySelectorAll('[data-ws-notes-count]').forEach(function (el) { el.textContent = n > 0 ? (' (' + n + ')') : ''; });
  }
  function index(notes) {
    var pendingVids = [];
    Object.keys(byVariant).forEach(function (v) { if (byVariant[v] === 'pending') pendingVids.push(v); });
    byVariant = {};
    (notes || []).forEach(function (n) { if (n.variant_id) byVariant[String(n.variant_id)] = n.note_id; });
    pendingVids.forEach(function (v) { if (!byVariant[v]) byVariant[v] = 'pending'; });
  }

  function ready() {
    if (readyP) return readyP;
    if (!api) { readyP = Promise.resolve(null); return readyP; }
    var c = api.cached ? api.cached() : null;
    if (c) { clientId = c.client_id; index(c.notes); noteCount = (c.notes || []).length; render(); }
    readyP = api.context().then(function (ctx) {
      if (ctx) { clientId = ctx.client_id; index(ctx.notes); noteCount = (ctx.notes || []).length; render(); }
      return ctx;
    }).catch(function () { return null; });
    return readyP;
  }

  W.add = function (item) {
    item = item || {};
    var vid = item.variant_id ? String(item.variant_id) : '';
    if (!api) { W.toast('Not ready, please retry'); return Promise.resolve(false); }
    if (vid && byVariant[vid]) { W.toast('Already in your notes'); return Promise.resolve(false); }

    // Optimistic: confirm instantly, reconcile in the background.
    if (vid) byVariant[vid] = 'pending';
    pending++;
    render();
    W.toast('Added to notes');

    return ready().then(function () {
      // The context may have arrived while we waited; if it already knows
      // this variant, the note exists and there is nothing to write.
      if (vid && byVariant[vid] && byVariant[vid] !== 'pending') {
        pending = Math.max(0, pending - 1); render();
        return true;
      }
      return api.call('addNote', api.identity({
        client_id: clientId || '',
        style: item.style || '',
        color: item.color || '',
        variant_id: vid || '',
        handle: item.handle || ''
      })).then(function (resp) {
        pending = Math.max(0, pending - 1);
        if (resp && resp.ok && resp.data && resp.data.note_id) {
          if (vid) byVariant[vid] = resp.data.note_id;
          if (!resp.data.duplicate) noteCount++;
          render();
          return true;
        }
        // Roll back the optimistic add.
        if (vid && byVariant[vid] === 'pending') delete byVariant[vid];
        render();
        W.toast((resp && resp.error) ? resp.error : 'Could not add, please try again');
        return false;
      }).catch(function () {
        pending = Math.max(0, pending - 1);
        if (vid && byVariant[vid] === 'pending') delete byVariant[vid];
        render();
        W.toast('Could not add, please try again');
        return false;
      });
    });
  };

  W.remove = function (vid) {
    if (!api) return Promise.resolve(false);
    return ready().then(function () {
      var noteId = byVariant[String(vid)];
      if (!noteId || noteId === 'pending') return false;
      return api.call('removeNote', api.identity({ client_id: clientId || '', note_id: noteId })).then(function () {
        delete byVariant[String(vid)];
        noteCount = Math.max(0, noteCount - 1);
        render();
        return true;
      });
    });
  };

  W.count = function () { return noteCount + pending; };
  W.has = function (vid) { return !!byVariant[String(vid)]; };
  W.whenReady = function () { return ready(); };

  W.toast = function (text) {
    var t = document.querySelector('.ws-toast');
    if (!t) { t = document.createElement('div'); t.className = 'ws-toast'; document.body.appendChild(t); }
    t.textContent = text; t.classList.add('is-visible');
    clearTimeout(W._tt); W._tt = setTimeout(function () { t.classList.remove('is-visible'); }, 1800);
  };

  var st = document.createElement('style');
  st.textContent = '.ws-toast{position:fixed;left:50%;bottom:20px;transform:translateX(-50%) translateY(20px);background:#1C1C1C;color:#fff;padding:.7rem 1rem;font-size:.9rem;letter-spacing:.02em;opacity:0;pointer-events:none;transition:opacity .2s ease,transform .2s ease;z-index:99998;}.ws-toast.is-visible{opacity:1;transform:translateX(-50%) translateY(0);}';
  document.head.appendChild(st);

  ready();
})();
